import getFiltersOption from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { getUserConfiguration } from 'owa-session-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('saveFiltersOptionHelper', function saveFiltersOptionHelper() {
    const filtersOptionState = getFiltersOption();
    const userConfiguration = getUserConfiguration();
    const mailboxJunkEmailConfiguration = getMailboxJunkEmailConfiguration();

    if (filtersOptionState.trustedListsOnly != null) {
        mailboxJunkEmailConfiguration.TrustedListsOnly = filtersOptionState.trustedListsOnly;
    }
    if (filtersOptionState.contactsTrusted != null) {
        mailboxJunkEmailConfiguration.ContactsTrusted = filtersOptionState.contactsTrusted;
    }
    if (filtersOptionState.blockContentFromUnknownSenders != null) {
        userConfiguration.SafetyUserOptions.BlockContentFromUnknownSenders =
            filtersOptionState.blockContentFromUnknownSenders;
    }
});
